import axios from "axios";

interface ICreateBookingNoteParams {
    bookingId: string,
    body: string
}

export const createBookingNote = async (params: ICreateBookingNoteParams): Promise<void> => {
    const response = await axios.post(`/booking/${params.bookingId}/note`, {
        note: params.body
    });
    return response.data;
};
